import React, { useRef, useEffect, useState } from "react";
import SanityBlockContent from "@sanity/block-content-to-react";
import { LinkReadStyle } from "../styles/LinkReadText";

function MyLinkRenderer(props) {
  return (
    <a
      href={props.mark.href}
      target="_blank"
      rel="noreferrer"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  );
}

const serializers = {
  marks: {
    link: MyLinkRenderer,
  },
};

export default function ReadMoreBox({ readMore, text, setReadMore }) {
  const contentRef = useRef(null);
  const textRef = useRef(null);
  const [showReadMoreButton, setShowReadMoreButton] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isTruncated =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setShowReadMoreButton(isTruncated); // Show button if text is truncated
    }
    if (readMore) {
      setShowReadMoreButton(true);
    }
  }, [text, readMore]); // Re-run when text changes

  const handleReadMoreClick = (e) => {
    e.preventDefault();
    const shouldExpand = !readMore;
    setReadMore(shouldExpand);
    if (shouldExpand) {
      // Delay the scroll until the next render cycle after state is updated
      scrollToAdjustedPosition(e);
    }
  };

  const scrollToAdjustedPosition = (e) => {
    if (
      contentRef.current &&
      contentRef.current.parentElement &&
      contentRef.current.parentElement.parentElement
    ) {
      const element = contentRef.current.parentElement.parentElement;
      const rect = element.getBoundingClientRect(); // Get the position of the element relative to the viewport
      const offset = window.pageYOffset + rect.top; // Calculate absolute top position
      const offsetWithNavbar = offset - window.innerHeight * 0.085; // Subtract 10% of the viewport height to adjust for navbar

      window.scrollTo({
        top: offsetWithNavbar,
        behavior: "smooth",
      });
    }
  };

  return (
    <LinkReadStyle readmore={readMore ? 1 : 0} ref={contentRef}>
      {text && (
        <p
          className="read-more big-ellipsis"
          ref={textRef}
          style={{ overflow: "hidden" }}
        >
          {text}
        </p>
      )}
      {showReadMoreButton && (
        <a
          className="read-more-btn text-green"
          href="#"
          onClick={handleReadMoreClick}
        >
          <p>Read {readMore ? "less" : "more"}</p>
        </a>
      )}
    </LinkReadStyle>
  );
}
